import styles from "../../styles/applicationDetail.module.css";
import type { ApplicationNotesListEmptyProps } from "../../types/components";

/** Angular note-list empty template (#emptyData). */
export function ApplicationNotesListEmpty({
  variant = "card",
  testId,
}: ApplicationNotesListEmptyProps) {
  if (variant === "inline") {
    return (
      <div className={styles.notesListEmptyCell} data-testid={testId}>
        No Notes
      </div>
    );
  }

  return (
    <div className={styles.notesEmptyWrap} data-testid={testId}>
      <div className={styles.notesEmptyState}>No Notes</div>
    </div>
  );
}
